import { api } from '@/lib/api';
import type {
  IApiResponse,
  IInsightChatRequest,
  IInsightChatResponse,
  IMetricViewInsightRequest,
  IMetricViewInsightResponse,
} from '@skystone/shared';

export const insightApi = {
  ask: async (
    body: IMetricViewInsightRequest,
  ): Promise<IMetricViewInsightResponse> => {
    const result = await api.post<IApiResponse<IMetricViewInsightResponse>>(
      '/insight/metric-view',
      body,
    );
    return result.data;
  },

  chat: async (
    body: IInsightChatRequest,
  ): Promise<IInsightChatResponse> => {
    const result = await api.post<IApiResponse<IInsightChatResponse>>(
      '/insight/chat',
      body,
    );
    return result.data;
  },
};
